/* NEKROS Premium — interacciones (scroll, carrito, feedback) */
(function () {
  if (window.__nkInit) return; window.__nkInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var THRESHOLD = 4999000; // $49.990 CLP en centavos (10% OFF automático)

  function money(c) {
    try { return new Intl.NumberFormat('es-CL', { style: 'currency', currency: 'CLP', maximumFractionDigits: 0 }).format(Math.round(c / 100)); }
    catch (e) { return '$' + Math.round(c / 100); }
  }
  function toast(msg) {
    var t = document.querySelector('.nk-toast');
    if (!t) { t = document.createElement('div'); t.className = 'nk-toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.classList.add('is-on');
    clearTimeout(t._h); t._h = setTimeout(function () { t.classList.remove('is-on'); }, 2200);
  }
  window.nkToast = toast;

  /* 1) Aparición al deslizar */
  function initReveal(root) {
    var els = (root || document).querySelectorAll('[data-nk-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }

  /* 2) Progreso de scroll por sección (--p de 0 a 1) */
  var scrollers = [];
  function initScrollers() {
    scrollers = Array.prototype.slice.call(document.querySelectorAll('[data-nk-progress]'));
    document.querySelectorAll('[data-nk-words]').forEach(function (el) {
      if (el._split) return; el._split = true;
      var words = el.textContent.trim().split(/\s+/);
      el.innerHTML = words.map(function (w) { return '<span class="nk-w">' + w + '</span>'; }).join(' ');
    });
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return; ticking = true;
    requestAnimationFrame(function () {
      var vh = window.innerHeight;
      scrollers.forEach(function (s) {
        var r = s.getBoundingClientRect();
        var p;
        if (s.hasAttribute('data-nk-inview')) {
          p = Math.min(1, Math.max(0, (vh * 0.9 - r.top) / (vh * 0.55 + r.height * 0.35)));
        } else {
          var total = r.height - vh; if (total <= 0) total = r.height;
          p = Math.min(1, Math.max(0, -r.top / total));
        }
        if (reduce) p = 0;
        s.style.setProperty('--p', p.toFixed(4));
        var words = s.querySelectorAll('.nk-w');
        if (words.length) {
          var lit = Math.round(p * 1.25 * words.length);
          words.forEach(function (w, i) { w.classList.toggle('is-lit', reduce || i < lit); });
        }
      });
      ticking = false;
    });
  }

  /* 3) Historia con imagen fija */
  function initStories() {
    document.querySelectorAll('[data-nk-story]').forEach(function (story) {
      if (story._ok) return; story._ok = true;
      var steps = story.querySelectorAll('[data-nk-step]');
      var imgs = story.querySelectorAll('[data-nk-media]');
      if (!('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          var i = +en.target.getAttribute('data-nk-step');
          steps.forEach(function (s) { s.classList.toggle('is-active', +s.getAttribute('data-nk-step') === i); });
          imgs.forEach(function (m) { m.classList.toggle('is-active', +m.getAttribute('data-nk-media') === i); });
        });
      }, { rootMargin: '-45% 0px -45% 0px' });
      steps.forEach(function (s) { io.observe(s); });
    });
  }

  /* 4) Carruseles: barra de progreso */
  function initRails() {
    document.querySelectorAll('[data-nk-rail]').forEach(function (rail) {
      if (rail._ok) return; rail._ok = true;
      var bar = rail.parentNode.querySelector('.nk-rail__bar span');
      if (!bar) return;
      function upd() { var max = rail.scrollWidth - rail.clientWidth; var p = max > 0 ? rail.scrollLeft / max : 1; bar.style.transform = 'scaleX(' + Math.max(.12, p) + ')'; }
      rail.addEventListener('scroll', upd, { passive: true }); upd();
    });
  }

  /* 5) Copiar código */
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-nk-copy]');
    if (!b) return;
    var code = b.getAttribute('data-nk-copy');
    var done = function () { b.classList.add('nk-bump'); setTimeout(function () { b.classList.remove('nk-bump'); }, 500); toast('Código ' + code + ' copiado'); if (navigator.vibrate) navigator.vibrate(12); };
    if (navigator.clipboard) navigator.clipboard.writeText(code).then(done, done); else done();
  });

  /* 6) Feedback al agregar al carrito */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.action || f.action.indexOf('/cart/add') === -1) return;
    var btn = f.querySelector('[type="submit"]');
    if (btn) { btn.classList.remove('nk-bump'); void btn.offsetWidth; btn.classList.add('nk-bump'); }
    if (navigator.vibrate) navigator.vibrate(15);
    setTimeout(refreshCartBars, 900);
  }, true);

  /* 7) Barra de progreso en carrito (10% OFF automático sobre $49.990) */
  function barHTML(cart) {
    var sub = cart.items_subtotal_price || cart.total_price || 0;
    var done = sub >= THRESHOLD;
    var pct = Math.min(100, Math.round(sub / THRESHOLD * 100));
    var msg = done ? '¡Listo! Tienes <strong>10% OFF automático</strong> en tu compra.'
      : 'Te faltan <strong>' + money(THRESHOLD - sub) + '</strong> para el <strong>10% OFF automático</strong>.';
    return '<div class="nk-cartbar' + (done ? ' is-done' : '') + '" data-nk-cartbar>' +
      '<p class="nk-cartbar__msg">' + msg + '</p>' +
      '<div class="nk-cartbar__track"><div class="nk-cartbar__fill" style="width:' + pct + '%"></div></div></div>';
  }
  var cartTimer;
  function refreshCartBars() {
    clearTimeout(cartTimer);
    cartTimer = setTimeout(function () {
      var targets = document.querySelectorAll('cart-drawer .drawer__footer, #CartDrawer .drawer__footer, .cart__footer, #main-cart-footer .cart__blocks');
      if (!targets.length) return;
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          targets.forEach(function (t) {
            var old = t.querySelector('[data-nk-cartbar]'); if (old) old.remove();
            if (!cart.item_count) return;
            t.insertAdjacentHTML('afterbegin', barHTML(cart));
          });
        }).catch(function () {});
    }, 150);
  }
  function watchCart() {
    var drawer = document.querySelector('cart-drawer, #CartDrawer');
    if (drawer && 'MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var n = muts[i].target;
          if (n.closest && n.closest('[data-nk-cartbar]')) continue;
          refreshCartBars(); break;
        }
      }).observe(drawer, { childList: true, subtree: true });
    }
    refreshCartBars();
  }

  function boot() {
    initReveal(); initScrollers(); initStories(); initRails(); onScroll(); watchCart();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { initReveal(e.target); initScrollers(); initStories(); initRails(); onScroll(); });
})();
